module.exports = __webpack_public_path__ + "static/img/jx.f3ec67a2.png";